import React, {useContext} from 'react';
import {AppContext} from '../../context/app/appContext';

export const SettingsNotifications = () => {
    return (
        <div>This is Notifications Page</div>
    )
}